"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import { useProviders } from "@/hooks/use-providers";
import { formatStaffName } from "@/lib/format-data";
import MultiSelectInput from "./multi-select";
import { FilterProps } from "./types";
const ProviderFilter: React.FC<FilterProps> = t0 => {
  const $ = _c(12);
  const {
    value,
    onChange
  } = t0;
  const {
    providers,
    isLoading
  } = useProviders();
  let t1;
  bb0: {
    if (!providers) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] !== providers) {
      t2 = providers.map(_temp);
      $[1] = providers;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = t2;
  }
  const options = t1;
  if (isLoading) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="px-2 py-3 text-center text-body text-muted-foreground">Loading providers...</div>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== value) {
    t2 = Array.isArray(value) ? value : value != null ? [value] : [];
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== onChange) {
    t3 = newValue => {
      if (newValue && newValue.length > 0) {
        onChange(newValue[newValue.length - 1]);
      } else {
        onChange(undefined);
      }
    };
    $[6] = onChange;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== options || $[9] !== t2 || $[10] !== t3) {
    t4 = <MultiSelectInput options={options} showBulkActions={false} value={t2} onChange={t3} />;
    $[8] = options;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default ProviderFilter;
function _temp(p) {
  return {
    label: formatStaffName(p),
    value: p.id
  };
}